import { useMutation } from '@tanstack/react-query';

import { PostSignupPayload, PostSignupResponse } from '@/api/userAccount/types';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';
import { uriEncodeObjectProperties } from '@/utils';

export const postSignup = (payload: PostSignupPayload): Promise<PostSignupResponse> => {
    // we have to encodeURIComponent the values because API expects it and performs a decodeURIComponent on the values
    return axios.post('/register', uriEncodeObjectProperties(payload));
};

type UsePostSignupOptions = {
    config?: MutationConfig<typeof postSignup>;
    data?: PostSignupPayload;
};

export const usePostSignup = ({ config }: UsePostSignupOptions = {}) => {
    return useMutation({
        ...config,
        mutationFn: postSignup,
    });
};
